enum AllBrightErrorType {
  ERROR_MESSAGE = "ERROR_MESSAGE",
  ERROR_NOTIFICATION = "ERROR_NOTIFICATION",
}

export default AllBrightErrorType;
